module.exports = "https://cdn.realtymogul.com/static/media/RP_1600golf.516351bd.jpg";